import {Component, OnInit} from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {Observable} from "rxjs";
import {Page} from "../util/Page";
import {DatePipe} from "@angular/common";
import {Customer} from "../customer/customer.component";
import {Pageable} from "../util/Pageable";
import {PageEvent} from "@angular/material/paginator";
import {ContractEditDialogComponent} from "./dialog/contract.edit.dialog.component";
import {DialogService} from "../util/DialogService";
import {environment} from "../../environments/environment";
import {Helper} from "../util/Helper";
import {SystemSmall} from "../system/system-list/system-list.component";

@Component({
    selector: 'app-contract',
    templateUrl: './contract.component.html',
    styleUrls: ['./contract.component.css'],
    standalone: false
})
export class ContractComponent implements OnInit {

  helper = Helper;
  allContracts: any = [];
  length: number = 0;
  pageSize: number = 10;
  pageEvent: any;
  displayedColumns: string[] = ['id', 'customer', 'system', 'customerReference', 'invoiceUnit', 'productType', 'additionalFeatures', 'basicCharge', 'amount', 'usedLicenses', 'unitPrice', 'billingInterval', 'discountInPercent', 'startOfContract', 'earnings'];

  constructor(private http: HttpClient, private dialogServiceEdit: DialogService<ContractEditDialogComponent>) {
  }

  getContracts(pageable: Pageable): Observable<Page<Contract[]>> {

    const options = pageable ?
      {params: new HttpParams().set('page', pageable.page).set('size', pageable.size)} : {};

    return this.http.get<Page<Contract[]>>(environment.apiURL + '/cc/contracts?sort=customer.name,asc', options);
  }

  ngOnInit(): void {
    this.getContracts(new Pageable(0, this.pageSize)).subscribe({
      next: (response) => {
        this.allContracts = response.content;
        this.length = response.totalElements;
      }
    });
  }

  openEditDialog() {
    this.dialogServiceEdit.open(ContractEditDialogComponent, {
      height: '400px',
      width: '600px',
    });
  }

  onPaginateChange($event: PageEvent) {
    this.getContracts(new Pageable($event.pageIndex, $event.pageSize)).subscribe({
      next: (response) => {
        this.allContracts = response.content;
      }
    });
  }

  getVolume(contract: Contract): string {
    let additionalFeaturesPrice = 0;
    if(contract.additionalFeatures != null){
      contract.additionalFeatures.forEach((additionalFeature) => {
        additionalFeaturesPrice += (additionalFeature.amount * additionalFeature.unitPrice);
      });
    }
    let monthly = (contract.amount * contract.unitPrice) + additionalFeaturesPrice + contract.basicCharge;
    monthly = monthly - (monthly * contract.discountInPercent / 100);

    let quaterly = monthly * 4;
    let semiAnnually = monthly * 6;
    let annually = monthly * 12;

    return "mtl. " + this.helper.centToEuro(monthly) + " <br> vj. " + this.helper.centToEuro(quaterly) + " <br> halbj. " + this.helper.centToEuro(semiAnnually) + " <br> jährl. " + this.helper.centToEuro(annually);
  }

  countLicenses(contract: Contract): number {
    let licenses = 0;
    contract.systems.forEach((system) => {
      licenses += system.usedLicenses;
    });
    return licenses;
  }
}

export enum InvoiceUnit {
  USER, INSTITUTION
}

export enum ProductType {
  TAGEA_CLOUD, TAGEA_INDIVIDUAL, TREMAZE_CLOUD, TREMAZE_INDIVIDUAL
}

export enum BillingInterval {
  MONTHLY, QUARTERLY, SEMI_ANNUALLY, ANNUALLY
}

export interface Contract {
  id: string;
  customerReference: string;
  customer: Customer
  systems: SystemSmall[];
  invoiceUnit: InvoiceUnit;
  productType: ProductType;
  basicCharge: number;
  amount: number;
  unitPrice: number;
  billingInterval: BillingInterval
  discountInPercent: number;
  startOfContract: DatePipe;

  additionalFeatures: ContractAdditionalFeature[];
}

export interface AdditionalFeature {
  id: string;
  name: string;
  defaultPricePerUnit: number;
}

export interface ContractAdditionalFeature {
  id: string;
  amount: number;
  unitPrice: number;
  discountInPercent: number;
  additionalFeature: AdditionalFeature;
}
